import { Pipe, PipeTransform } from '@angular/core';
import { slugify } from '../library/utils';

@Pipe({
  name: 'slugify'
})
export class SlugifyPipe implements PipeTransform {

  transform(text: string, args?: any): string {
    return slugify(text);
  }

}
